import { Slider } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";

type Filtros = {
  temDiferencial?: boolean;
  precoRange?: [number, number];
  duracaoRange?: [number, number];
  reviews?: number[];
};

type FlightFilterProps = {
  onFilterChange: (valores: Partial<Filtros>) => void;
};

const FlightFilter: React.FC<FlightFilterProps> = ({ onFilterChange }) => {
  const [filtros, setFiltros] = useState<Filtros>({
    temDiferencial: false,
    precoRange: [0, 8000],
    duracaoRange: [0, 480],
    reviews: [],
  });

  const atualizarFiltro = (campo: keyof Filtros, valor: any) => {
    const novosFiltros = { ...filtros, [campo]: valor };
    setFiltros(novosFiltros);
    onFilterChange(novosFiltros); // 🔥 emite para o grid aplicar no front
  };

  const resetFiltros = () => {
    const valoresPadrao: Filtros = {
      temDiferencial: false,
      precoRange: [200, 8000],
      duracaoRange: [30, 480],
      reviews: [],
    };
    setFiltros(valoresPadrao);
    onFilterChange(valoresPadrao);
  };

  return (
    <div className="col-xl-3 col-lg-3">
      <div className="card filter-sidebar mb-4 mb-lg-0 theiaStickySidebar">
        <div className="card-header d-flex align-items-center justify-content-between">
          <h5>Filters</h5>
          <Link to="#" className="fs-14 link-primary" onClick={resetFiltros}>
            Reset
          </Link>
        </div>

        <div className="card-body p-0">
          <form>
            <div className="accordion accordion-list">
              {/* Diferenciais */}
              <div className="accordion-item border-bottom p-3">
                <div className="accordion-header">
                  <div
                    className="accordion-button p-0"
                    data-bs-toggle="collapse"
                    data-bs-target="#accordion-diferenciais"
                    aria-expanded="true"
                    role="button"
                  >
                    <i className="isax isax-ranking me-2 text-primary"></i>
                    Diferenciais
                  </div>
                </div>
                <div
                  id="accordion-diferenciais"
                  className="accordion-collapse collapse show"
                >
                  <div className="accordion-body pt-2">
                    <div className="form-check d-flex flex-column ps-0 mb-2">
                      <div className="d-flex align-items-center">
                        <input
                          className="form-check-input ms-0 mt-0"
                          type="checkbox"
                          id="diferencial1"
                          checked={filtros.temDiferencial}
                          onChange={(e) =>
                            atualizarFiltro("temDiferencial", e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label ms-2 fw-medium"
                          htmlFor="diferencial1"
                        >
                          Tem diferencial
                        </label>
                      </div>
                      <small className="text-muted ms-4">
                        (fornece água, comida e etc)
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              {/* Preço */}
              <div className="accordion-item border-bottom p-3">
                <div className="accordion-header">
                  <div
                    className="accordion-button p-0"
                    data-bs-toggle="collapse"
                    data-bs-target="#accordion-price"
                    aria-expanded="true"
                    role="button"
                  >
                    <i className="isax isax-coin me-2 text-primary"></i>Preço
                  </div>
                </div>
                <div
                  id="accordion-price"
                  className="accordion-collapse collapse show"
                >
                  <div className="accordion-body">
                    <Slider
                      range
                      min={0}
                      max={10000}
                      value={filtros.precoRange}
                      onChange={(val) =>
                        atualizarFiltro("precoRange", val as [number, number])
                      }
                    />
                    <div className="filter-range-amount">
                      <p className="fs-14">
                        Range:{" "}
                        <span className="text-gray-9 fw-medium">
                          R${filtros.precoRange?.[0]} - R${filtros.precoRange?.[1]}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Duração */}
              <div className="accordion-item border-bottom p-3">
                <div className="accordion-header">
                  <div
                    className="accordion-button p-0"
                    data-bs-toggle="collapse"
                    data-bs-target="#accordion-duration"
                    aria-expanded="true"
                    role="button"
                  >
                    <i className="isax isax-timer me-2 text-primary"></i>
                    Duração
                  </div>
                </div>
                <div
                  id="accordion-duration"
                  className="accordion-collapse collapse show"
                >
                  <div className="accordion-body">
                    <Slider
                      range
                      min={0}
                      max={1440}
                      value={filtros.duracaoRange}
                      onChange={(val) =>
                        atualizarFiltro("duracaoRange", val as [number, number])
                      }
                    />
                    <div className="filter-range-amount">
                      <p className="fs-14">
                        Range:{" "}
                        <span className="text-gray-9 fw-medium">
                          {filtros.duracaoRange?.[0]}min - {filtros.duracaoRange?.[1]}min
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Reviews */}
              <div className="accordion-item border-bottom p-3">
                <div className="accordion-header">
                  <div
                    className="accordion-button p-0"
                    data-bs-toggle="collapse"
                    data-bs-target="#accordion-reviews"
                    aria-expanded="true"
                    role="button"
                  >
                    <i className="isax isax-discount-shape me-2 text-primary"></i>
                    Reviews
                  </div>
                </div>
                <div
                  id="accordion-reviews"
                  className="accordion-collapse collapse show"
                >
                  <div className="accordion-body">
                    {[5, 4, 3, 2, 1].map((star) => (
                      <div
                        className="form-check d-flex align-items-center ps-0 mb-2"
                        key={star}
                      >
                        <input
                          className="form-check-input ms-0 mt-0"
                          type="radio"
                          name="reviewsFilter"
                          id={`review${star}`}
                          checked={filtros.reviews?.[0] === star}
                          onChange={() => {
                            const novas = filtros.reviews?.[0] === star ? [] : [star];
                            atualizarFiltro("reviews", novas);
                          }}
                        />
                        <label
                          className="form-check-label ms-2"
                          htmlFor={`review${star}`}
                        >
                          <span className="rating d-flex align-items-center">
                            {Array(star)
                              .fill(0)
                              .map((_, i) => (
                                <i
                                  className="fas fa-star filled text-warning me-1"
                                  key={i}
                                ></i>
                              ))}
                            <span className="ms-2">{star}★ or more</span>
                          </span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FlightFilter;
